import { createFileRoute } from "@tanstack/react-router"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import { useDocumentTitle } from "@/lib/useDocumentTitle"

const contactData = {
  name: "Martin Kupski",
  street: "Bergkämpe",
  houseNr: "6",
  city: "32312 Lübbecke",
  telephoneNr: "05741 298338",
  mobileNr: "0170 4700820",
  email: "martin@pianoservice-kupski.de",
}

export const Route = createFileRoute("/impressum")({
  component: ImpressumPage,
})

function ImpressumPage() {
  useDocumentTitle("Impressum - Pianoservice Kupski")
  const { name, street, houseNr, city, telephoneNr, mobileNr, email } =
    contactData

  return (
    <div className="flex flex-col flex-1 items-center py-8 px-4">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="font-serif text-primary text-3xl">
            Impressum
          </CardTitle>
        </CardHeader>
        <CardContent className="prose dark:prose-invert">
          <h2>Angaben gemäß § 5 DDG</h2>
          <p>
            {name}
            <br />
            Pianoservice Kupski
            <br />
            {street} {houseNr}
            <br />
            {city}
          </p>

          <Separator className="my-6" />

          <h2>Kontakt</h2>
          <p>
            Telefon: {telephoneNr}
            <br />
            Mobil: {mobileNr}
            <br />
            E-Mail:{" "}
            <a
              href={`mailto:${email}`}
              className="hover:text-primary transition-colors"
            >
              {email}
            </a>
          </p>

          <Separator className="my-6" />

          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 DDG für eigene Inhalte auf
            diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            Art. 6 der Verordnung (EU) 2022/2065 (Digital Services Act) sind wir
            als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
            gespeicherte fremde Informationen zu überwachen oder nach Umständen
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon
            unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
            Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
            Inhalte umgehend entfernen.
          </p>

          <Separator className="my-6" />

          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>

          <Separator className="my-6" />

          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
